<template>
  <div>
    <section class="page-not-found">
      <div class="container">
        <div class="row cRow">
          <div class="col-sm-5">
            <div class="pnf-content text-center">
              <div class="big-text">500</div>
              <h1>Relax..</h1>
              <p>
                Take it easy just let it go, it's about not paying the electricity bills.
              </p>
              <router-link to="/">
                <div class="btn btn-primary">Try again</div>
              </router-link>
            </div>
            <!-- /.pnf-content -->
          </div>
          <!-- /.col-sm-5 -->
          <div class="col-sm-7">
            <img :src="cdn + '/images/500.png'" class="img-responsive" alt="" />
          </div>
          <!-- /.col-sm-7 -->
        </div>
        <!-- /.row -->
      </div>
    </section>
  </div>
</template>

<script>
export default {
  computed: {
    cdn: function () {
      return process.env.VUE_APP_CDN;
    },
  },
  beforeDestroy() {
    location.reload();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/shared/500.vue